"use client";

// src/components/atoms/landing/cookie-preferences-link.tsx
// Footer trigger that re-opens the cookie preferences panel after the user has
// already made a choice. Dispatches a global event consumed by
// <CookieConsentProvider>.

import { dispatchOpenPreferences } from "@/lib/consent";

export function CookiePreferencesLink({ label = "Cookie preferences" }: { label?: string }) {
  return (
    <button
      type="button"
      onClick={dispatchOpenPreferences}
      className="inline-flex min-h-11 items-center text-xs text-brand-ink/70 transition-colors hover:text-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:rounded-sm"
    >
      {label}
    </button>
  );
}
